import { render } from "./MotionPay.vue?vue&type=template&id=4a7b20f2&scoped=true"
const script = {}

import "./MotionPay.vue?vue&type=style&index=0&id=4a7b20f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7b20f2"]])

export default __exports__